import * as v from 'valibot';
import { IdSchema, TimestampSchema } from './common.js';
import { NumberingConfigSchema } from './room.js';
export const FolderSchema = v.object({
    id: IdSchema,
    kind: v.optional(v.literal('folder')),
    roomId: IdSchema,
    parentId: v.optional(v.nullable(IdSchema)),
    name: v.pipe(v.string(), v.minLength(1), v.maxLength(255)),
    displayNumber: v.pipe(v.string(), v.minLength(1)),
    numberingConfig: v.optional(v.nullable(NumberingConfigSchema)),
    sortOrder: v.pipe(v.number(), v.integer(), v.minValue(0)),
    createdAt: TimestampSchema
});
export const CreateFolderSchema = v.object({
    roomId: IdSchema,
    parentId: v.optional(v.nullable(IdSchema)),
    name: v.pipe(v.string(), v.minLength(1), v.maxLength(255))
});
export const UpdateFolderSchema = v.partial(v.object({
    name: v.pipe(v.string(), v.minLength(1), v.maxLength(255)),
    numberingConfig: v.nullable(NumberingConfigSchema),
    sortOrder: v.pipe(v.number(), v.integer(), v.minValue(0))
}));
export const RenumberFolderSchema = v.object({
    folderId: IdSchema,
    start: v.pipe(v.number(), v.integer(), v.minValue(1))
});
export const RenumberContainerSchema = v.object({
    items: v.array(v.object({
        type: v.picklist(['folder', 'file']),
        id: IdSchema
    })),
    numberingConfig: v.optional(NumberingConfigSchema)
});
//# sourceMappingURL=folder.js.map